// removed by extract-text-webpack-plugin
module.exports = {"Topics__heading":"src-components-topics----topics-module---Topics__heading---1fwN-","Topic":"src-components-topics----topics-module---Topic---32tln","Topic__content":"src-components-topics----topics-module---Topic__content---omVdW","Topic__name":"src-components-topics----topics-module---Topic__name---cyTZJ","Topic__description":"src-components-topics----topics-module---Topic__description---36HDM","spinAround":"src-components-topics----topics-module---spinAround---Q3Kpb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/topics/topics.module.scss
// module id = 289
// module chunks = 35783957827783